module.exports = __webpack_public_path__ + "img/04-covariates.7abbe168.svg";